import React, { useState, useEffect, useRef, useContext } from 'react';
import { coreAxios } from "utilities/axios";

import { classNames } from 'primereact/utils';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { FileUpload } from 'primereact/fileupload';
import { Rating } from 'primereact/rating';
import { Toolbar } from 'primereact/toolbar';
import { InputTextarea } from 'primereact/inputtextarea';
import { RadioButton } from 'primereact/radiobutton';
import { InputNumber } from 'primereact/inputnumber';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Card } from 'primereact/card';
import { Divider } from 'primereact/divider';


//NEW
import AuthContext from  "../../context/AuthContext";
import { ConfirmPopup } from 'primereact/confirmpopup'; // To use <ConfirmPopup> tag
import { confirmPopup } from 'primereact/confirmpopup'; // To use confirmPopup method
import { useSelector, useDispatch } from "react-redux";
import { GetInvoices, GetSaleDetail, DeleteInvoice } from 'services/saleDetails/saleDetails.service';

import { Table } from 'components/Table/Table';
import { TableDetailInvoice } from 'components/Table/TableDetailInvoice';
import { NameColumn, TextColumn, LinkColumn } from 'components/Table/ColumnTemplates/CustomColumn';
const BASE_URL = process.env.REACT_APP_MAIN_URL

const SaleDetails = () => {
    const { invoiceList, invoiceListLoading } = useSelector((state) => state.invoiceList);
    const { saleDetail, saleDetailLoading } = useSelector((state) => state.saleDetail);

    const [showDetail, setShowDetail] = useState(false); //* state for form modal

    const { user } = useContext(AuthContext);


    const [selectedData, setSelectedData] = useState([])
    const dispatch = useDispatch();

    // delete 1
    const toast = useRef(null);

    const DeleteModal =  (event, id) => {

        confirmPopup({
            target: event.currentTarget,
            message: 'Do you want to delete this record?',
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            accept: async () => {
                await dispatch(DeleteInvoice(id))
                await toast.current.show({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted', life: 3000 });
                await dispatch(GetInvoices(user?.shop_id));
            },
            reject: () => {
                toast.current.show({ severity: 'warn', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
            }
        });
    };

    const saleDetails = (invoice) => {

        setShowDetail(true); // * set the form to true
        dispatch(GetSaleDetail(invoice?.id))
        // setUpdateData(chalan);
    };
    const downloadInvoice = async (data) => {
 
        const url = `${BASE_URL}/api/invoice/download/${data.id}/`;
        try {
            const response = await coreAxios.get(url, {
                responseType: 'blob',
            });
            const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', `invoice-${data.invoice_no}.pdf`);
            document.body.appendChild(link);
            link.click();
        } catch(error){
            console.log(error)
        }
    }

    // modal hide function
    const hideModal = () => {
        setShowDetail(false);
    };


    useEffect(() => {
        dispatch(GetInvoices(user?.shop_id));
    }, []);


    // columns of the table with header name
    const tableColumns = [
        { field: "invoice_no", header: "Invoice No", sortableBody: TextColumn },
        { field: "emp_code", header: "Employee Code", sortableBody: TextColumn },
        { field: "date", header: "Date", sortableBody: TextColumn },
        { field: "total_price", header: "Total price", sortableBody: TextColumn },
    ];

    const detailTableColumns = [
        { field: "stock_name", header: "Item", sortableBody: NameColumn },
        { field: "stock_code", header: "Item Code", sortableBody: NameColumn },
        { field: "stock_uom", header: "Item Uom", sortableBody: NameColumn },
        { field: "rate", header: "Rate", sortableBody: TextColumn },
        { field: "quantity", header: "Quantity", sortableBody: TextColumn },
        { field: "total_price_per_item", header: "Price", sortableBody: TextColumn },
    ];


    const actionBodyTemplate = (rowData) => {
        return (
            <>
            
            <div className="actions">
                <Button 
                    icon="pi pi-list" 
                    className="p-button-outlined p-button-info mr-2" 
                    onClick={(e) => {
                        saleDetails(rowData)
                    }}
                />
                <Toast ref={toast} />
                <ConfirmPopup />
                <Button 
                    icon="pi pi-download" 
                    className="p-button-outlined p-button-info mr-2" 
                    onClick={(e) => {
                        downloadInvoice(rowData)
                    }}
                />
                <Button 
                    onClick={(e) => {
                        DeleteModal(e, rowData.id);
                    }} 
                    icon="pi pi-trash" 
                    className="p-button-rounded p-button-warning mt-2"
                />
            </div>
            </>
        );
    }

    return (
        <>
            <Table
                //data
                tableHeaderName="Invoice Details"
                tableColumns={tableColumns}
                data={invoiceList}
                loading={invoiceListLoading}
                dataKey="id"
                rows={25}
                sortable
                exportBtn
                searchField
                isRowSelectable
                selectedData = {selectedData}
                setSelectedData = {setSelectedData}
                actionButton={actionBodyTemplate}
                // setShowCreateModal={setShowForm}
                hideLeftToolbar={true}
            />

            <Dialog 
                visible={showDetail} 
                style={{ width: "1400px" }} 
                // header="Chalan Details"
                className="p-fluid" 
                onHide={hideModal} 
                position="top"
                modal closeOnEscape blockScroll icons focusOnShow resizable maximizable
            >
                
                <Divider align="center">
                    <span className="p-tag">Sale Items Details</span>
                </Divider>

                <TableDetailInvoice
                    tableColumns={detailTableColumns}
                    data={saleDetail}
                    loading={saleDetailLoading}
                    dataKey="id"
                />
            </Dialog>
        </>
    );
};

export default SaleDetails;
